module.exports = __webpack_public_path__ + "img/logo-jne.a53963df.png";